import React, { useState, useEffect } from "react";
import { useAppContext } from "../../AppContext";
import Stories from "react-insta-stories";
import "../../style/Body/StoriesFast.css";

export default function StoriesFast() {
  const { globalState, setGlobalState } = useAppContext();
  const handleChangeEnd = () => {
    setGlobalState({
      ...globalState,
      aditionalNavbar:true
    })
  }

  const [heightSonStyle, setheightSonStyle] = useState({height:350});

  const handlerSizeScreen =()=>{
    if(window.matchMedia("(min-width: 800px)").matches){
      setheightSonStyle({});
    } else if(window.matchMedia("(max-height: 680px)").matches) {
      setheightSonStyle({height:350, margin:'auto'});
    } else {
      setheightSonStyle({margin:'auto'});
    }
  }

  useEffect(() => {
    handlerSizeScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="stories-size">
      <Stories
        stories={globalState.images}
        defaultInterval={4000}
        onAllStoriesEnd={() => handleChangeEnd()}
        height='100%'
        storyStyles={{margin:'auto'}}
        preventDefault
      />
    </div>
  );
}
